<template>
  <b-container>
    <b-row>
      <b-col cols="12" md="3" v-for="lecture in lectures" :key="lecture.id">
        <b-card
          :title="lecture.name"
          :sub-title="lecture.nickName"
          :img-src="lecture.image"
          img-alt="Image"
          img-top
          tag="article"
          style="max-width: 20rem;"
          class="mb-5"
          align="center"
          sub-title-text-variant="info"
        >
          <b-card-text>{{ lecture.career1 }}</b-card-text>
          <b-card-text>{{ lecture.career2 }}</b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      lectures: [
        {
          category: "Coding 교육",
          id: 5,
          image: require("@/assets/images/teamImages/team_pacman.jpg"),
          name: "김태선",
          nickName: "pacman",
          career1: " Professional Learning Specialist",
          career2: "(전) NHN Connect "
        },
        {
          category: "Makers 교육",
          id: 88,
          image: require("@/assets/images/teamImages/team_wannabewize.jpg"),
          name: "이재훈",
          nickName: "wannabewize",
          career1: "T 아카데미 iOS 강사",
          career2: "VanillaStep 대표"
        },
        {
          category: "UX Design 교육",
          id: 6,
          image: require("@/assets/images/teamImages/team_black.jpg"),
          name: "남장혁",
          nickName: "black",
          career1: "코더스하이 강사"
        },
        {
          category: "App Development 교육",
          id: 8,
          image: require("@/assets/images/teamImages/team_wannabewize.jpg"),
          name: "이재훈",
          nickName: "wannabewize",
          career1: "T 아카데미 iOS 강사",
          career2: "VanillaStep 대표"
        },
        {
          category: "App Development 교육",
          id: 7,
          image: require("@/assets/images/teamImages/team_mocona.jpg"),
          name: "박종영",
          nickName: "mocona",
          career1: "이바닥닷컴 대표"
        },
        {
          category: "App Development 교육",
          id: 2,
          image: require("@/assets/images/teamImages/team_devkang.jpg"),
          name: "강희종",
          nickName: "devkang",
          career1: "(주)카루랩 CTO",
          career2: "iOS / Web Developer"
        },
        {
          category: "App Development 교육",
          id: 3,
          image: require("@/assets/images/teamImages/team_goya.jpg"),
          name: "고준일",
          nickName: "goya",
          career1: "모카포트 대표",
          career2: "(전)호서대 겸임교수"
        },
        {
          category: "커리큘럼 지원",
          id: 4,
          image: require("@/assets/images/teamImages/team_gwang.jpg"),
          name: "김광호",
          nickName: "활어광어",
          career1: "Apple & TED & NG Educator",
          career2: "미래교실네트워크 / 거꾸로캠퍼스 교사"
        }
      ]
    };
  }
};
</script>

<style scoped>
.img-responsive {
  display: block;
  width: auto;
  height: 244px;
}
.card {
  height: 90%;
}
</style>
